<template>
  <div>
    <h2 class="mt-1 ml-15 hidden-sm-and-down grey--text">Ecommerce</h2> <!-- Full Screen -->
    <h3 class="mt-1 hidden-sm-and-up grey--text">Ecommerce</h3> <!-- Mobile Screen --> 
    <div class="mt-5">
      <v-divider></v-divider>
      <!-- <v-bottom-navigation :value="value" color="success">
        <v-btn @click="OpenComponent(0)" :disabled="comp0">      
          <span>Orden</span>
          <v-icon>{{OrdenIcon}}</v-icon>
        </v-btn>
        <v-btn @click="OpenComponent(1)" :disabled="comp1">
          <span>Conciliar</span>
          <v-icon>{{ConciliarIcon}}</v-icon>
        </v-btn>
        <v-btn @click="OpenComponent(2)" :disabled="comp2">
          <span>Publicar</span>
          <v-icon>{{PublicarIcon}}</v-icon>
        </v-btn>
      </v-bottom-navigation> -->
      <div v-if="AutorizaEcommerce=='V'" class="mt-7">
          <div v-if="fullEcommerce==true">
            <component v-bind:is="componente" :usu="usu" :contrato="contrato"></component>
          </div>
          <div v-if="fullEcommerce==false" class="mt-5">
            <v-card>
              <v-card-subtitle><v-icon class="red--text">cancel</v-icon><span class="ml-2">Solicitud Denegada</span></v-card-subtitle>
            </v-card>
          </div>

      
      </div>
      <div v-if="AutorizaEcommerce=='N'">
        <v-row class="mt-15">
          <v-col cols="1" md="4"></v-col>
          <v-col cols="10" md="4">
            <v-card rounded="xl">
              <v-card-text>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <span class="text-body-2">
                            Este módulo no está incluido en tu plan actual.
                            <br><br>
                            Puedes activarlo en cualquier momento como un complemento independiente, sin necesidad de cambiar de plan
                            <br><br>
                            Comunicate con soporte o visita nuestro sitio Web
                            <br>
                            <a target="_blank" href="https://www.controlparts.cl">www.controlparts.cl</a>
                        </span>
                    </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="1" md="4"></v-col>
        </v-row>
      </div>
    </div>
    <dialogo :loading="loading"  />
  </div>
</template>

<script>
import axios from 'axios';
// import Orden from '@/components/Orden.vue';
import Orden from '@/components/Orden_Ecommerce.vue';
import Conciliar from '@/components/Conciliar.vue';
import Publicar from '@/components/Publicar.vue';
import dialogo from '@/components/dialogo.vue';
export default {
  name: 'ecommerce',
  components: { Orden, Conciliar, Publicar ,dialogo},
  props: ['usu','contrato'],
  data(){
    return{
      loading:false,
      value:0,
      componente:'',
      IconSelect:'check_circle',
      OrdenIcon:'check_circle',
      ConciliarIcon:'swap_vertical_circle',
      PublicarIcon:'public',
      comp0:true,
      comp1:true,
      comp2:true,
      fullEcommerce:null,
      AutorizaEcommerce:''
    }
  },
  async mounted(){
    const auth = await this.AuthModules();
    if(auth=='V'){
      await this.entrada();
    }
  },
  methods:{
    async AuthModules(){
      let result = 'N'
        try {
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/autoriza_modulos/'+this.contrato);
            const datos=response.data;
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    const key = element.Modulo;
                    if(key == "Ecommerce"){
                        result = element.Estado;
                        this.AutorizaEcommerce = element.Estado
                    }
                });
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async entrada(){
      this.loading=true;
      const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/usuarios/'+ this.contrato +'/'+ this.usu);
      const datos=response.data;
      if (datos[0].existe=='si'){
        if (datos[0].Ecommerce!=0){
            this.fullEcommerce=true
            this.comp0=false;
            this.comp1=false; // cambiar a false para Habilitar modulo
            this.comp2=false; // cambiar a false para Habilitar modulo
            this.OpenComponent(0);
        } else {
            this.fullEcommerce=false
            this.comp0=true;
            this.comp1=true;
            this.comp2=true;
        };
      } 
      this.loading=false;
    },
    OpenComponent(value){
      let vComponente;
      switch (value) {
        case 0:
          vComponente='Orden';
          this.OrdenIcon=this.IconSelect;
          this.ConciliarIcon='swap_vertical_circle';
          this.PublicarIcon='public';
          break;
        case 1:
          vComponente='Conciliar';
          this.OrdenIcon='library_books';
          this.ConciliarIcon=this.IconSelect;
          this.PublicarIcon='public';
          break;
        case 2:
          vComponente='Publicar';
          this.OrdenIcon='library_books';
          this.ConciliarIcon='swap_vertical_circle';
          this.PublicarIcon=this.IconSelect;
          break;
      }
      this.componente=vComponente;
    }
  }
}
</script>